module.exports = __webpack_public_path__ + "img/lsp-workshop-step-3.db98e54d.jpg";